import { URLS } from "@app/shared";
import steelImage from "@assets/images/sectors/steel-sector-icon.jpeg";
import { PageHeader } from "@design-system/components";
import { Header } from "@design-system/layouts";
import { trans } from "@mongez/localization";
import { useMemo } from "react";
import { SectorItemsSection, SectorSubsidersSection } from "../components";
import { KeyServicesSection } from "../components/KeyServicesSection";
import { Sector } from "../types";

type SectorDetailsPageProps = {
  sector: Sector;
};

const getSectorIcon = (slug: string) => {
  switch (slug) {
    case "fabricated-sector":
      return steelImage;
    default:
      return undefined;
  }
};

export function SectorDetailsPage({ sector }: SectorDetailsPageProps) {
  const sectorIcon = useMemo(() => {
    return getSectorIcon(sector.slug);
  }, [sector]);

  return (
    <section className="relative bg-marine pb-12 text-white lg:pb-24">
      <Header color={sector.color} className="relative" />

      <PageHeader
        translationKey={sector.title}
        breadcrumbItems={[
          {
            label: "home",
            link: URLS.home,
          },
          { label: sector.title },
        ]}
        image={sector.image.url}
        color={sector.color}
      >
        <p className="text-sm text-white/70 sm:text-base lg:w-[95%] lg:text-lg">
          {trans(sector.description)}
        </p>
      </PageHeader>

      {/* <SectorHeroSection
        color={sector.color}
        data={sector}
        breadcrumbItems={[
          {
            label: "home",
            link: URLS.home,
          },
          { label: sector.title },
        ]}
      >
        <p className="text-sm text-white/70 sm:text-base lg:text-lg">
          {trans(sector.description)}
        </p>
      </SectorHeroSection> */}
      <KeyServicesSection services={sector.services} icon={sectorIcon} />
      <SectorItemsSection items={sector.items} />
      <SectorSubsidersSection subsidiaries={sector.subsidiaries} />
    </section>
  );
}
